import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UrlSettingsCore } from '../../../../core/configuration/url-settings-core';
import { OperationsService } from '../../../../core/services/operations.service';
import { RoutingConfigurationUtilService } from '../../../../core/services/routing-configuration-util.service';
import { FascicoloMap } from '../../../models/fascicolo-map';
import { Fascicolo } from '../../../models/fascicolo/fascicolo';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { Pratica } from '../../../models/pratica/pratica';
import { DefinisciFascicoloConcreteFormComponent } from './definisci-fascicolo-concrete-form.component';

declare var removeEmptyObject: any;
declare var closeModal: any;
declare var openModal: any;
declare var getFascicoloMapSync: any;

@Component({
    selector: 'div [fascicolo-definisci-modal]',
  templateUrl: 'definisci-fascicolo-modal.component.html'
})

export class FascicoloDefinisciModal {
  private fascicolo: Fascicolo;
  private pratica: Pratica;
  @Output() onReturn: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('formDefinisciFascicolo') formDefinisciFascicolo: DefinisciFascicoloConcreteFormComponent;
  @Output() onReturnFascicolo: EventEmitter<FascicoloFull> = new EventEmitter<FascicoloFull>();

  constructor(
    private operationService: OperationsService,
    private router: Router,
    private routingService: RoutingConfigurationUtilService
  ) {}

  inizializza(fascicolo: Fascicolo, pratica: Pratica, recallFascicolo: boolean) {

    if (recallFascicolo) {
        // let nomeFascicoloFE: string = FrontEndMapping.tipiFascicolo[fascicolo.tipoFascicolo.id];
        // let nomePraticaFE: string = FrontEndMapping.tipiPratica[pratica.tipoPratica.id];
        let fascicoloMap: FascicoloMap =  <FascicoloMap> getFascicoloMapSync(pratica.tipoPratica.id, fascicolo.tipoFascicolo.id);
        this.operationService.readFascicolo(fascicoloMap.pathView, fascicolo.id ).subscribe(response => this.inizializzaForm(response));
        this.pratica = pratica;
    } else {
      this.pratica = pratica;
      this.fascicolo = fascicolo;
      this.formDefinisciFascicolo.inizializza(fascicolo, pratica);
    }
    openModal('modaldefinisciFascicolo');
  }

  inizializzaForm(response) {
      this.formDefinisciFascicolo.inizializza(response.fascicolo, this.pratica);
      this.fascicolo = response.fascicolo;
  }

  goToDatiGenerali() {
    closeModal('modaldefinisciFascicolo');
    this.router.navigate([this.routingService.getRoutingVisualizzazioneFascicoloModule(this.pratica.tipoPratica.id, this.fascicolo.tipoFascicolo.id) + '/' + UrlSettingsCore.URL_VISUALIZZA_SEZIONE_DATI_GENERALI, this.fascicolo.id ]);
  }

  manageModal(esitoOperazione: boolean) {
      closeModal('modaldefinisciFascicolo');
      this.onReturn.emit(esitoOperazione);
      if (this.fascicolo) {
        if (esitoOperazione) {
            // let nomeFascicoloFE: string = FrontEndMapping.tipiFascicolo[this.fascicolo.tipoFascicolo.id];
            // let nomePraticaFE: string = FrontEndMapping.tipiPratica[this.pratica.tipoPratica.id];
            let fascicoloMap: FascicoloMap =  <FascicoloMap> getFascicoloMapSync(this.pratica.tipoPratica.id, this.fascicolo.tipoFascicolo.id);
          this.operationService.readFascicolo(fascicoloMap.pathView, this.fascicolo.id ).subscribe(response => this.onReturnFascicolo.emit(response.fascicolo));
        }
      }
  }
}
